export const getters = {
  getClaims: (state) => {
    return state.claims;
  },
  getCurrentClaim: (state) => {
    return state.claim;
  }
};
